module.exports = __webpack_public_path__ + "img/kelvin.4b33ecce.jpg";